import { render, staticRenderFns } from "./ResumeProducts.vue?vue&type=template&id=1473c517&scoped=true"
import script from "./ResumeProducts.vue?vue&type=script&lang=js"
export * from "./ResumeProducts.vue?vue&type=script&lang=js"
import style0 from "./ResumeProducts.vue?vue&type=style&index=0&id=1473c517&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1473c517",
  null
  
)

export default component.exports